import {
    AggregatedByAndSubPlotValue,
    DEFAULT_PLOT_RANGE,
    DropdownSelection,
    Localization,
    SegmentSelect,
    Tab,
    SideModalTitle,
    Region,
    Dma,
    SelectionPerAnnum,
    DEFAULT_PLOT_RANGE_UK,
} from 'utils';
import categorySpendDataUS from '../../JSON/Category spend_SUBCATEGORY_GEO_NAME.json';
import populationDataUS from '../../JSON/Population_All population_GEO_NAME.json';
import demographicDataUS from '../../JSON/Demographic_ETH_GRP_GEO_NAME.json';
import disposableDataUS from '../../JSON/Business opportunity_SEM_scenario_GEO_NAME.json';
import driversOfGrowthUS from '../../JSON/DriverOfGrowth.json';
import populationDataUK from '../../JSON/UK/Population.json';
import demographicDataUK from '../../JSON/UK/Demographic.json';
import disposableIncomeDataUK from '../../JSON/UK/DisposableIncome.json';
import categorySpendDataUK from '../../JSON/UK/CategorySpend.json';
import driversOfGrowthDataUK from '../../JSON/UK/DriversOfGrowth.json';
import {
    BusinessSelectionUS,
    BusinessSelectionUK,
    CategorySpendSelectionUS,
    CategorySpendSelectionUK,
    DemographicSelectionUS,
    DemographicSelectionUK,
    PopulationSelectionUS,
    PopulationSelectionUK,
    DriversOfGrowthsSelectionUS,
    DriversOfGrowthsSelectionUK,
} from '../DefaultSelection/projectionDefaultSelections';

export const projectionsInitial: Record<any, any> = {
    [Localization.US]: {
        tabs: {
            [Tab.POPULATION]: {
                title: Tab.POPULATION,
                sideModalTitle: SideModalTitle.POPULATION_GROUPS,
                selectionData: PopulationSelectionUS,
                selectionState: {
                    hareSelection: {
                        aggregatedBy: AggregatedByAndSubPlotValue.ALL_POPULATION,
                        subPlot: AggregatedByAndSubPlotValue.NONE,
                    },
                    range: DEFAULT_PLOT_RANGE,
                    dropdownVariants: {
                        [DropdownSelection.GROUP_BY]: true,
                        [DropdownSelection.SHOW_BY]: true,
                        [DropdownSelection.X_AXIS]: false,
                    },
                },
                selectionVariants: {
                    isRegionShow: true,
                    isCategoryShow: false,
                    isSubcategoriesShow: false,
                    isEthnicShow: true,
                    isAgeShow: true,
                    isSexShow: true,
                    isIncomeShow: true,
                },
                withSidePanel: true,
                legendPosition: 'top',
                tortoiseUpdated: true,
                data: populationDataUS,
            },
            [Tab.DEMOGRAPHIC]: {
                title: Tab.DEMOGRAPHIC,
                sideModalTitle: SideModalTitle.DEMOGRAPHIC_GROUPS,
                selectionData: DemographicSelectionUS,
                selectionState: {
                    hareSelection: {
                        aggregatedBy: AggregatedByAndSubPlotValue.ETHNIC_GROUP,
                        subPlot: AggregatedByAndSubPlotValue.NONE,
                    },
                    range: DEFAULT_PLOT_RANGE,
                    dropdownVariants: {
                        [DropdownSelection.GROUP_BY]: true,
                        [DropdownSelection.SHOW_BY]: true,
                        [DropdownSelection.X_AXIS]: false,
                    },
                },
                selectionVariants: {
                    isRegionShow: true,
                    isCategoryShow: false,
                    isSubcategoriesShow: false,
                    isEthnicShow: true,
                    isAgeShow: true,
                    isSexShow: true,
                    isIncomeShow: true,
                },
                withSidePanel: true,
                legendPosition: 'top',
                tortoiseUpdated: true,
                data: demographicDataUS,
            },
            [Tab.DISPOSABLE_INCOME]: {
                title: Tab.DISPOSABLE_INCOME,
                sideModalTitle: SideModalTitle.MOBILITY_SCENARIOS,
                selectionData: BusinessSelectionUS,
                selectionState: {
                    perAnnum: SelectionPerAnnum.CUMULATIVE,
                    hareSelection: {
                        aggregatedBy: AggregatedByAndSubPlotValue.SOCIO_ECONOMIC,
                        subPlot: AggregatedByAndSubPlotValue.NONE,
                    },
                    range: DEFAULT_PLOT_RANGE,
                    dropdownVariants: {
                        [DropdownSelection.GROUP_BY]: true,
                        [DropdownSelection.SHOW_BY]: true,
                        [DropdownSelection.X_AXIS]: false,
                    },
                },
                selectionVariants: {
                    isRegionShow: true,
                    isCategoryShow: false,
                    isSubcategoriesShow: false,
                    isEthnicShow: true,
                    isAgeShow: true,
                    isSexShow: true,
                    isIncomeShow: true,
                },
                withSidePanel: true,
                legendPosition: 'top',
                tortoiseUpdated: true,
                data: disposableDataUS,
            },
            [Tab.CATEGORY_SPEND]: {
                title: Tab.CATEGORY_SPEND,
                sideModalTitle: SideModalTitle.CATEGORIES,
                selectionData: CategorySpendSelectionUS,
                selectionState: {
                    perAnnum: SelectionPerAnnum.CUMULATIVE,
                    hareSelection: {
                        aggregatedBy: AggregatedByAndSubPlotValue.SUBCATEGORY,
                        subPlot: AggregatedByAndSubPlotValue.NONE,
                    },
                    range: DEFAULT_PLOT_RANGE,
                    dropdownVariants: {
                        [DropdownSelection.GROUP_BY]: true,
                        [DropdownSelection.SHOW_BY]: true,
                        [DropdownSelection.X_AXIS]: false,
                    },
                },
                selectionVariants: {
                    isRegionShow: true,
                    isCategoryShow: true,
                    isSubcategoriesShow: true,
                    isEthnicShow: true,
                    isAgeShow: true,
                    isSexShow: true,
                    isIncomeShow: true,
                },
                withSidePanel: true,
                legendPosition: 'top',
                tortoiseUpdated: true,
                data: categorySpendDataUS,
            },
            [Tab.DRIVERS_OF_GROWTH]: {
                title: Tab.DRIVERS_OF_GROWTH,
                sideModalTitle: SideModalTitle.POPULATION_SPEND,
                selectionData: DriversOfGrowthsSelectionUS,
                selectionState: {
                    hareSelection: {
                        subPlot: AggregatedByAndSubPlotValue.NONE,
                        xAxis: AggregatedByAndSubPlotValue.SUBCATEGORY,
                    },
                    year: 2030,
                    dropdownVariants: {
                        [DropdownSelection.GROUP_BY]: false,
                        [DropdownSelection.SHOW_BY]: true,
                        [DropdownSelection.X_AXIS]: true,
                    },
                },
                selectionVariants: {
                    isRegionShow: true,
                    isCategoryShow: true,
                    isSubcategoriesShow: true,
                    isEthnicShow: true,
                    isAgeShow: true,
                    isSexShow: true,
                    isIncomeShow: true,
                },
                withSidePanel: true,
                legendPosition: 'top',
                tortoiseUpdated: true,
                data: driversOfGrowthUS,
            },
        },
        currentTab: {
            title: Tab.POPULATION,
        },
        geoMapSelectionAllTabs: {
            Segment: SegmentSelect.REGION,
            REGION: [Region.WEST, Region.MIDWEST, Region.SOUTH, Region.NORTHEAST],
            DMA: Dma.NEW_YORK_NY,
        },
        isLoading: false,
        dataLoaded: false,
        error: '',
    },
    [Localization.UK]: {
        tabs: {
            [Tab.POPULATION]: {
                title: Tab.POPULATION,
                sideModalTitle: SideModalTitle.POPULATION_GROUPS,
                selectionData: PopulationSelectionUK,
                selectionState: {
                    hareSelection: {
                        aggregatedBy: AggregatedByAndSubPlotValue.ALL_POPULATION,
                        subPlot: AggregatedByAndSubPlotValue.NONE,
                    },
                    range: DEFAULT_PLOT_RANGE_UK,
                    dropdownVariants: {
                        [DropdownSelection.GROUP_BY]: true,
                        [DropdownSelection.SHOW_BY]: true,
                        [DropdownSelection.X_AXIS]: false,
                    },
                },
                selectionVariants: {
                    isRegionShow: false,
                    isCategoryShow: false,
                    isSubcategoriesShow: false,
                    isEthnicShow: true,
                    isAgeShow: true,
                    isSexShow: true,
                    isIncomeShow: true,
                },
                withSidePanel: true,
                legendPosition: 'top',
                tortoiseUpdated: true,
                data: populationDataUK,
            },
            [Tab.DEMOGRAPHIC]: {
                title: Tab.DEMOGRAPHIC,
                sideModalTitle: SideModalTitle.DEMOGRAPHIC_GROUPS,
                selectionData: DemographicSelectionUK,
                selectionState: {
                    hareSelection: {
                        aggregatedBy: AggregatedByAndSubPlotValue.ETHNIC_GROUP,
                        subPlot: AggregatedByAndSubPlotValue.NONE,
                    },
                    range: DEFAULT_PLOT_RANGE_UK,
                    dropdownVariants: {
                        [DropdownSelection.GROUP_BY]: true,
                        [DropdownSelection.SHOW_BY]: true,
                        [DropdownSelection.X_AXIS]: false,
                    },
                },
                selectionVariants: {
                    isRegionShow: false,
                    isCategoryShow: false,
                    isSubcategoriesShow: false,
                    isEthnicShow: true,
                    isAgeShow: true,
                    isSexShow: true,
                    isIncomeShow: true,
                },
                withSidePanel: true,
                legendPosition: 'top',
                tortoiseUpdated: true,
                data: demographicDataUK,
            },
            [Tab.DISPOSABLE_INCOME]: {
                title: Tab.DISPOSABLE_INCOME,
                sideModalTitle: SideModalTitle.MOBILITY_SCENARIOS,
                selectionData: BusinessSelectionUK,
                selectionState: {
                    perAnnum: SelectionPerAnnum.CUMULATIVE,
                    hareSelection: {
                        aggregatedBy: AggregatedByAndSubPlotValue.SOCIO_ECONOMIC,
                        subPlot: AggregatedByAndSubPlotValue.NONE,
                    },
                    range: DEFAULT_PLOT_RANGE_UK,
                    dropdownVariants: {
                        [DropdownSelection.GROUP_BY]: true,
                        [DropdownSelection.SHOW_BY]: true,
                        [DropdownSelection.X_AXIS]: false,
                    },
                },
                selectionVariants: {
                    isRegionShow: false,
                    isCategoryShow: false,
                    isSubcategoriesShow: false,
                    isEthnicShow: true,
                    isAgeShow: true,
                    isSexShow: true,
                    isIncomeShow: true,
                },
                withSidePanel: true,
                legendPosition: 'top',
                tortoiseUpdated: true,
                data: disposableIncomeDataUK,
            },
            [Tab.CATEGORY_SPEND]: {
                title: Tab.CATEGORY_SPEND,
                sideModalTitle: SideModalTitle.CATEGORIES,
                selectionData: CategorySpendSelectionUK,
                selectionState: {
                    perAnnum: SelectionPerAnnum.CUMULATIVE,
                    hareSelection: {
                        aggregatedBy: AggregatedByAndSubPlotValue.SUBCATEGORY,
                        subPlot: AggregatedByAndSubPlotValue.NONE,
                    },
                    range: DEFAULT_PLOT_RANGE_UK,
                    dropdownVariants: {
                        [DropdownSelection.GROUP_BY]: true,
                        [DropdownSelection.SHOW_BY]: true,
                        [DropdownSelection.X_AXIS]: false,
                    },
                },
                selectionVariants: {
                    isRegionShow: false,
                    isCategoryShow: true,
                    isSubcategoriesShow: true,
                    isEthnicShow: true,
                    isAgeShow: true,
                    isSexShow: true,
                    isIncomeShow: true,
                },
                withSidePanel: true,
                legendPosition: 'top',
                tortoiseUpdated: true,
                data: categorySpendDataUK,
            },
            [Tab.DRIVERS_OF_GROWTH]: {
                title: Tab.DRIVERS_OF_GROWTH,
                sideModalTitle: SideModalTitle.POPULATION_SPEND,
                selectionData: DriversOfGrowthsSelectionUK,
                selectionState: {
                    hareSelection: {
                        subPlot: AggregatedByAndSubPlotValue.NONE,
                        xAxis: AggregatedByAndSubPlotValue.SUBCATEGORY,
                    },
                    year: 2030,
                    dropdownVariants: {
                        [DropdownSelection.GROUP_BY]: false,
                        [DropdownSelection.SHOW_BY]: true,
                        [DropdownSelection.X_AXIS]: true,
                    },
                },
                selectionVariants: {
                    isRegionShow: false,
                    isCategoryShow: true,
                    isSubcategoriesShow: true,
                    isEthnicShow: true,
                    isAgeShow: true,
                    isSexShow: true,
                    isIncomeShow: true,
                },
                withSidePanel: true,
                legendPosition: 'top',
                tortoiseUpdated: true,
                data: driversOfGrowthDataUK,
            },
        },
        currentTab: {
            title: Tab.POPULATION,
        },
        geoMapSelectionAllTabs: {
            Segment: SegmentSelect.REGION,
            REGION: [Region.WEST, Region.MIDWEST, Region.SOUTH, Region.NORTHEAST],
            DMA: Dma.NEW_YORK_NY,
        },
        isLoading: false,
        dataLoaded: false,
        error: '',
    },
};
